import BasePrepareModel from './base-prepare-model';
import CPUtils from '../../cp-utils';
import { htmlToSdkScale } from '../../lib/ParserUtils';
import type { ISdkModel } from '../../store-manager';

class ImagePrepareModel extends BasePrepareModel {
    public base64UrlTempMap: Map<string, string>|undefined;
    /**
     * 转为html的过程
     * @param htmlData
     * @returns {string}
     */
    public getHtml(htmlData: ISdkModel): string {
        const containerTag = document.createElement('div');
        const imageSdkData = this.getFirstSelectedElement(htmlData);
        this.insertPrivateData(containerTag, htmlData);
        containerTag.innerHTML = containerTag.innerHTML + this.getImageHtml(imageSdkData);
        return containerTag.outerHTML;
    }

    /**
     * 将图片转为html的过程
     * @param imageSdkData
     * @returns
     */
    private getImageHtml(imageSdkData) {
        const newSdkData = imageSdkData?.inheritedSdkData ?? imageSdkData;
        const imageUrl = newSdkData?.blipFill?.blip?.embed;
        const base64Url = this.base64UrlTempMap?.get(imageUrl);
        return this.convertSDkDataToHtmlString(imageSdkData, imageUrl, base64Url);
    }

    private convertSDkDataToHtmlString(imageSdkData, imageUrl: string, base64Url: string|undefined): string {
        const newSdkData = imageSdkData.isPlaceholder ? imageSdkData.copyDataByInheritedProperties() : imageSdkData;
        const frameWidth = newSdkData?.spPr?.xfrm?.ext?.cx;
        const frameHeight = newSdkData?.spPr?.xfrm?.ext?.cy;
        const width = frameWidth > 0 ? frameWidth / htmlToSdkScale : 0;
        const height = frameHeight > 0 ? frameHeight / htmlToSdkScale : 0;
        const addonData = CPUtils.stringifyAddonData(imageSdkData);
        const html = `<img src="${base64Url || imageUrl}" style="width: ${width}px; height: ${height}px;"${addonData}/>`;
        return html;
    }
}

export default ImagePrepareModel;
